
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/react-native",
      function () {
        return require("private-next-pages/docs/link/react-native/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/react-native"])
      });
    }
  